import React from 'react';

const PrivacyPolicyPage = () => {
  return (
    <div style={{ background: '#0a1d38', fontFamily: 'Lato, sans-serif', fontWeight: 400, padding: '24px' }}>
      <div style={{ background: '#ffffff', borderRadius: '32px 32px 0 0', padding: '32px 24px' }}>
        <div style={{ margin: '0 auto', maxWidth: '1000px' }}>
          <p style={{ fontSize: '24px', lineHeight: '30px', color: '#213554', margin: 0, fontWeight: 700 }}>Privacy Policy</p>
          <div style={{ width: '28px', height: '5px', backgroundColor: '#213554', marginTop: '16px' }}></div>
          <p style={{ margin: '16px 0 0', color: '#213554ab', fontWeight: 700 }}>Last updated on Feb 20th 2025</p>

          <p style={{ color: '#515978', margin: '16px 0 0', fontSize: '14px', lineHeight: '20px' }}>
            This privacy policy sets out how Rx Pharma uses and protects any information that you give Rx Pharma when you visit their website and/or agree to purchase from them.
          </p>

          <p style={{ color: '#515978', margin: '16px 0 0', fontSize: '14px', lineHeight: '20px' }}>
            Rx Pharma is committed to ensuring that your privacy is protected. Should we ask you to provide certain information by which you can be identified when using this website, you can be assured that it will only be used in accordance with this privacy statement.
          </p>

          <p style={{ color: '#515978', margin: '16px 0 0', fontSize: '14px', lineHeight: '20px' }}>
            Rx Pharma may change this policy from time to time by updating this page. You should check this page from time to time to ensure that you adhere to these changes.
          </p>

          <p style={{ color: '#515978', margin: '16px 0 0', fontSize: '14px', lineHeight: '20px', fontWeight: 'bold' }}>We may collect the following information:</p>
          <ul style={{ paddingLeft: '20px', color: '#515978', fontSize: '14px', lineHeight: '20px' }}>
            <li>Name</li>
            <li>Contact information including email address</li>
            <li>Demographic information such as postcode, preferences, and interests, if required</li>
            <li>Other information relevant to customer surveys and/or offers</li>
          </ul>

          <p style={{ color: '#515978', margin: '16px 0 0', fontSize: '14px', lineHeight: '20px', fontWeight: 'bold' }}>What we do with the information we gather:</p>
          <ul style={{ paddingLeft: '20px', color: '#515978', fontSize: '14px', lineHeight: '20px' }}>
            <li>Internal record keeping</li>
            <li>We may use the information to improve our products and services</li>
            <li>We may periodically send promotional emails about new products, special offers, or other information which we think you may find interesting using the email address which you have provided</li>
            <li>From time to time, we may also use your information to contact you for market research purposes</li>
          </ul>

          <p style={{ color: '#515978', margin: '16px 0 0', fontSize: '14px', lineHeight: '20px' }}>
            We are committed to ensuring that your information is secure. In order to prevent unauthorized access or disclosure, we have put in place suitable measures.
          </p>

          <p style={{ color: '#515978', margin: '16px 0 0', fontSize: '14px', lineHeight: '20px', fontWeight: 'bold' }}>How we use cookies:</p>
          <p style={{ color: '#515978', margin: '16px 0 0', fontSize: '14px', lineHeight: '20px' }}>
            A cookie is a small file which asks permission to be placed on your computer's hard drive. Once you agree, the file is added and the cookie helps analyze web traffic or lets you know when you visit a particular site.
          </p>
          <p style={{ color: '#515978', margin: '16px 0 0', fontSize: '14px', lineHeight: '20px' }}>
            Overall, cookies help us provide you with a better website, by enabling us to monitor which pages you find useful and which you do not. A cookie in no way gives us access to your computer or any information about you, other than the data you choose to share with us.
          </p>

          <p style={{ color: '#515978', margin: '16px 0 0', fontSize: '14px', lineHeight: '20px', fontWeight: 'bold' }}>Controlling your personal information:</p>
          <ul style={{ paddingLeft: '20px', color: '#515978', fontSize: '14px', lineHeight: '20px' }}>
            <li>Whenever you are asked to fill in a form on the website, look for the box that you can click to indicate that you do not want the information to be used for direct marketing purposes</li>
            <li>If you have previously agreed to us using your personal information for direct marketing purposes, you may change your mind at any time by writing to or emailing us</li>
          </ul>

          <p style={{ color: '#515978', margin: '16px 0 0', fontSize: '14px', lineHeight: '20px' }}>
            If you believe that any information we are holding on you is incorrect or incomplete, please contact us as soon as possible. We will promptly correct any information found to be incorrect.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;